<div
  class="shadow-basicButton w-[32px] h-[32px] bg-white border border-G300 rounded-[8px] p-[6px] select-none cursor-pointer hover:bg-G100 transition-all duration-300"
>
  <img
    src="/assets/massimo/svg/external-link.svg"
    alt="external-link"
    class="w-[20px] h-[20px] select-none"
  />
</div>
